import { render, staticRenderFns } from "./FailedAddStartupsModal.vue?vue&type=template&id=b544917c&scoped=true&"
import script from "./FailedAddStartupsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./FailedAddStartupsModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FailedAddStartupsModal.vue?vue&type=style&index=0&id=b544917c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b544917c",
  null
  
)

export default component.exports